<template>
  <!-- Cabecera con buscador integrada al estilo PickingMainExample.vue -->
  <ion-header>
    <ion-toolbar :color="color === undefined ? 'primary' : color" class="ion-justify-content-start ion-align-items-start">
      <ion-buttons slot="start">
        <ion-button size="default" color="light" routerLink="/home" routerDirection="none">
          <ion-icon :icon="homeSharp" color="light" class="muy-grande"></ion-icon>
        </ion-button>
      </ion-buttons>

      <ion-title>
        <ion-row class="ion-justify-content-start ion-align-items-start">
          <ion-col size="40" class="ion-float-left izquierda" :style="isIOS ? 'padding-left: 4rem !important;' : ''">
            {{ titulo }} ({{ pdv }})
          </ion-col>
        </ion-row>
      </ion-title>

      <ion-buttons slot="end" v-if="showBack">
        <ion-button size="default" color="light" :routerLink="previo ? '/' + previo : undefined" routerDirection="none" @click="goBack">
          <i class="fa-sharp fa-solid fa-circle-left muy-grande" color="light"></i>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <!-- Toolbar de búsqueda en la cabecera -->
    <ion-toolbar :color="color === undefined ? 'primary' : color" class="top" style="padding-top: 2px">
      <ion-searchbar
        :debounce="debounceMs"
        :placeholder="placeholder"
        v-model="query"
        id="busqueda_cabecera"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        show-clear-button="always"
        inputmode="search"
        type="search"
        @ionInput="onInput"
        @ionChange="onChange"
        @ionClear="onClear"
        slot="start"
        mode="md"
      />
    </ion-toolbar>
  </ion-header>
</template>

<script>
import { defineComponent } from 'vue'
import { homeSharp } from 'ionicons/icons'

export default defineComponent({
  name: 'CabeceraComponentBackSearch',
  props: {
    titulo: String,
    color: String,
    pdv: String,
    isIOS: Boolean,
    previo: String,
    modelValue: { type: String, default: '' },
    // retardo configurable del procesamiento; manejamos el debounce manualmente
    debounceMs: { type: Number, default: 500 },
    placeholder: { type: String, default: 'Buscar por fecha o estado' },
    showBack: { type: Boolean, default: true }
  },
  data () {
    return { homeSharp, query: this.modelValue }
  },
  watch: {
    // mantenemos sincronía con v-model externo
    modelValue (val) { this.query = val }
  },
  methods: {
    normalizeText (s) {
      const t = String(s || '')
        .replace(/\s+/g, ' ')
        .trim()
      return t
    },
    buildSearchSpec (raw) {
      const norm = this.normalizeText(raw)
      const isEmpty = !norm
      const tokens = isEmpty ? [] : norm.split(' ')
      const apply = (text) => {
        if (!text) return false
        if (isEmpty) return true
        const ht = String(text)
        let pos = 0
        for (let i = 0; i < tokens.length; i++) {
          const tk = tokens[i]
          const found = ht.indexOf(tk, pos)
          if (found === -1) return false
          pos = found + tk.length
        }
        return true
      }
      const applyArray = (arr) => {
        if (!Array.isArray(arr)) return false
        if (isEmpty) return true
        for (let i = 0; i < arr.length; i++) {
          if (apply(String(arr[i] || ''))) return true
        }
        return false
      }
      return { raw, norm, tokens, isEmpty, apply, applyArray }
    },
    onInput () {
      this.$emit('search-start')
    },
    // emite cambios tras debounce del ion-searchbar
    onChange () {
      this.$emit('update:modelValue', this.query)
      const spec = this.buildSearchSpec(this.query)
      this.$emit('search-change', spec)
      this.$emit('search-end', spec)
    },
    onClear () {
      this.query = ''
      const spec = this.buildSearchSpec('')
      this.$emit('update:modelValue', '')
      this.$emit('search-change', spec)
      this.$emit('search-end', spec)
    },
    goBack () {
      this.$emit('back-click')
      if (!this.previo) {
        if (window.history.length > 1) {
          this.$router.go(-1)
        } else {
          this.$router.push('/home')
        }
      }
    }
  },
  computed: {
    hasQuery () { return !!this.normalizeText(this.query) }
  },
  mounted () {}
})
</script>

<style scoped>
ion-title { width: 100% !important; padding-right: 4px; }
.izquierda { text-align: left; }
.muy-grande { font-size: 1.4rem; }
</style>
